import React, { HTMLProps } from 'react';
import dynamic from 'next/dynamic';

import { DatoCmsImageTheme } from 'lib/datoCms/types';
import { Navigation } from 'components/header/Header';

export type UserMenuProps = {
  showDetail: boolean;
  logoSnaiPi: DatoCmsImageTheme;
  buttonList?: Navigation[];
  currentIndex: number | string;
  handleShowDetailsMenu: Function;
} & HTMLProps<HTMLElement>;

const UserMenu = dynamic<UserMenuProps>(
  () => import('components/header/userMenu/UserMenu').then((mod) => mod.UserMenu),
  { ssr: false }
);

export { UserMenu };